// extracted by mini-css-extract-plugin
export default {"container-header":"ContainerHeader_container-header__J-uMI","container-header__title":"ContainerHeader_container-header__title__6YSPo"};